import styled from 'styled-components'
// @ts-expect-error // TODO
import MobileDrawerTop from '../../assets/skbv-bottom-drawer.svg?react'

export const Puller = styled(MobileDrawerTop)`
  display: block;
  width: 100%;
  height: auto;
  position: absolute;
  top: 80px;

  path.b {
    stroke-width: 4px;

    @media (min-width: 768px) {
      stroke-width: 2px;
    }
  }
`
